(function ($) {
	class W4D_R1Receipt {
		constructor() {
			this.initSelectors();

			if (this.$toggleR1.length) {
				this.handleMPFunctionality();
			}
		}

		initSelectors() {
			this.$toggleR1 = $('#toggle_r1');
		}

		handleMPFunctionality() {
			this.$billingCompanyField = $('[data-id="billing_company"]');
			this.$billingOibField = $('[data-id="billing_oib"]');
			this.$billingCompanyField.hide();
			this.$billingOibField.hide();

			this.$toggleR1.change(() => {
				const isChecked = this.$toggleR1.is(':checked');

				if (isChecked) {
					this.$billingCompanyField.slideDown({ duration: 400, queue: false }).fadeIn({ duration: 400, queue: false });
					this.$billingOibField.slideDown({ duration: 400, queue: false }).fadeIn({ duration: 400, queue: false });
				} else {
					this.$billingCompanyField.slideUp({ duration: 400, queue: false }).fadeOut({ duration: 400, queue: false });
					this.$billingOibField.slideUp({ duration: 400, queue: false }).fadeOut({ duration: 400, queue: false });
				}
			});
		}
	}

	$(document).ready(() => {
		new W4D_R1Receipt();
	});
})(jQuery);
